// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "details-BIiVv";
var _3 = "statusWrapper-RNj3J";
var _4 = "idWrapper-2q9N9";
var _5 = "prefix-3SZz2";
var _6 = "status-3nz-R";
var _7 = "id-pYj_Z";
var _8 = "status__new-3YyEG";
var _9 = "status__progress-3Mql0";
var _a = "status__solved-3tFBc";
var _b = "status__awaiting-25ya2";
var _c = "status__rejected-114KS";
export { _1 as "__esModule", _2 as "details", _3 as "statusWrapper", _4 as "idWrapper", _5 as "prefix", _6 as "status", _7 as "id", _8 as "status__new", _9 as "status__progress", _a as "status__solved", _b as "status__awaiting", _c as "status__rejected" }
export default { "__esModule": _1, "details": _2, "statusWrapper": _3, "idWrapper": _4, "prefix": _5, "status": _6, "id": _7, "status__new": _8, "status__progress": _9, "status__solved": _a, "status__awaiting": _b, "status__rejected": _c }
